import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles(() =>
  createStyles({
    loadingWrapper: {
      height: '100vh',
    },
  })
);
